import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Col,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import CustomerServices from "../../../../../services/OrderingServices/CustomerServices";
import toast from "react-hot-toast";
import Select from "react-select";
import CustomerTypeService from "../../../../../services/OrderingServices/CustomerTypeService";

const CustomerFormMobile = ({ isOpen, toggle, editingPackage, onSave }) => {
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const fetchCustomerType = async () => {
    try {
      const response = await CustomerTypeService.getList();
      setCustomerTypeData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCustomerType();
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: editingPackage?.email || "",
      firstName: editingPackage?.firstName || "",
      lastName: editingPackage?.lastName || "",
      phoneNo: editingPackage?.phoneNo || "",
      address: editingPackage?.address || "",
      customerTypeId: editingPackage?.customerTypeId || null,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email")
        .required("Please Enter Your Email"),
      firstName: Yup.string().required("Please Enter Your First Name"),
      lastName: Yup.string().required("Please Enter Your Last Name"),
      phoneNo: Yup.string().required("Please Enter Phone Number"),
      address: Yup.string(),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await CustomerServices.create(values);
        onSave(response);
        toggle();
        resetForm();
        toast.success("New customer added successfull.");
      } catch (error) {
        console.log(error);
      }
    },
  });

  const handleCustomerTypeChange = (selectedOption) => {
    formik.setFieldValue(
      "customerTypeId",
      selectedOption ? selectedOption.value : null
    );
  };

  const customerTypeOptions = customerTypeData.map((type) => ({
    value: type.id,
    label: type.name,
  }));
  const selectedCustomerType = customerTypeOptions.find(
    (option) => option.value === formik.values.customerTypeId
  );
  // Reset form when modal closes
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="bottom"
      scrollable={false}
      className="d-block d-lg-none"
      style={{
        height: "60vh",
        transition: "transform 0.3s ease",
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        zIndex: 1050,
      }}
    >
      {" "}
      <div className="d-flex flex-column h-100">
        <OffcanvasHeader toggle={toggle} className="">
          Add Customer
        </OffcanvasHeader>{" "}
        <OffcanvasBody>
          <Row>
            <Col lg={12} className="mb-3">
              <div className="form-floating">
                <Input
                  name="firstName"
                  className="form-control"
                  placeholder="Enter first name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                  invalid={
                    formik.touched.firstName && !!formik.errors.firstName
                  }
                />
                <Label>First Name</Label>
                {formik.touched.firstName && formik.errors.firstName && (
                  <FormFeedback>{formik.errors.firstName}</FormFeedback>
                )}
              </div>
            </Col>

            <Col lg={12} className="mb-3">
              <div className="form-floating">
                <Input
                  name="lastName"
                  className="form-control"
                  placeholder="Enter last name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                  invalid={formik.touched.lastName && !!formik.errors.lastName}
                />
                <Label>Last Name</Label>
                {formik.touched.lastName && formik.errors.lastName && (
                  <FormFeedback>{formik.errors.lastName}</FormFeedback>
                )}
              </div>
            </Col>

            <Col lg={12} className="mb-3">
              <div className="form-floating">
                <Input
                  name="email"
                  className="form-control"
                  placeholder="Enter email"
                  type="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  invalid={formik.touched.email && !!formik.errors.email}
                />
                <Label>Email address</Label>
                {formik.touched.email && formik.errors.email && (
                  <FormFeedback>{formik.errors.email}</FormFeedback>
                )}
              </div>
            </Col>

            <Col lg={12} className="mb-3">
              <div className="form-floating">
                <Input
                  name="phoneNo"
                  className="form-control"
                  placeholder="Phone Number"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phoneNo}
                  invalid={formik.touched.phoneNo && !!formik.errors.phoneNo}
                />
                <Label>Phone Number</Label>
                {formik.touched.phoneNo && formik.errors.phoneNo && (
                  <FormFeedback>{formik.errors.phoneNo}</FormFeedback>
                )}
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <Select
                  id="customerTypeId"
                  name="customerTypeId"
                  options={customerTypeOptions}
                  value={selectedCustomerType || null}
                  onChange={handleCustomerTypeChange}
                  placeholder="Select Customer Type"
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0.3rem",
                    }),
                  }}
                />
                {formik.touched.customerTypeId &&
                  formik.errors.customerTypeId && (
                    <div className="text-danger">
                      {formik.errors.customerTypeId}
                    </div>
                  )}
              </div>
            </Col>
          </Row>
        </OffcanvasBody>
        <div
          className="p-3 border-top bg-white shadow-lg d-flex gap-2"
          style={{ position: "sticky", bottom: 0, zIndex: 1060 }}
        >
          <button className="btn btn-soft-danger w-100" onClick={toggle}>
            Cancel
          </button>
          <button
            className="btn btn-success w-100"
            type="submit"
            onClick={formik.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </Offcanvas>
  );
};

export default CustomerFormMobile;
